export class ScriptActionsState {
  code: string
}
